// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const Layout = () => {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex flex-col w-full overflow-hidden">
        <Header />
        <div className="flex-1 overflow-auto p-6">
          <Outlet /> {/* ⬅️ Tempat child page seperti Dashboard dimuat */}
        </div>
      </div>
    </div>
  );
};

export default Layout;
